export const SET_PARTNER = 'PARTNER/SET_PARTNER'
export const SET_PARTNERS = 'PARTNER/SET_PARTNERS'
